// @flow
import axios from "axios";

import type { Axios } from "axios";

if (typeof process.env.REACT_APP_ORGANIZER_API_ORIGIN !== "string") {
  throw new Error("REACT_APP_ORGANIZER_API_ORIGIN is required");
}

const instance: Axios = axios.create({
  baseURL: process.env.REACT_APP_ORGANIZER_API_ORIGIN,
});

export default instance;
